import { render, staticRenderFns } from "./strictProduct2.vue?vue&type=template&id=509c030c&scoped=true"
import script from "./strictProduct2.vue?vue&type=script&lang=js"
export * from "./strictProduct2.vue?vue&type=script&lang=js"
import style0 from "./strictProduct2.vue?vue&type=style&index=0&id=509c030c&prod&lang=scss"
import style1 from "./strictProduct2.vue?vue&type=style&index=1&id=509c030c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509c030c",
  null
  
)

export default component.exports